"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = void 0;
// taken from https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_isempty
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isEmpty = (obj) => [Object, Array].includes((obj || {}).constructor) && !Object.entries(obj || {}).length;
exports.isEmpty = isEmpty;
//# sourceMappingURL=isEmpty.js.map